export const SERIES_ID_REGEXP = /^[a-zA-Z0-9_-]{21}$/;
export const SERIES_SLUG_REGEXP = /^[a-z0-9-]+$/;
export const ENS_NAME_REGEXP = /^[a-z0-9-]+\.eth$/;
export const ETH_ADDRESS_REGEXP = /^0x[0-9a-fA-F]{40}$/;
